import { LOCALES } from "../data/constants";

/**
 * Formats the date in a date object into a string
 *
 * @param {Date} date - the date to format
 * @returns
 */
export const formatDate = (date, locale = LOCALES.GERMAN) => {
  if (!date || !isDate(date)) {
    return null;
  }

  return new Intl.DateTimeFormat(locale, {
    month: "long",
    day: "2-digit",
    year: "numeric",
  }).format(date);
};

const isDate = (date) => {
  return date.constructor === Date;
};
